<template>
  <div :class="{ bordered: border,  shadow: boxShadow  }" class="awl-card">
    <div class="awl-card--header" v-if="$scopedSlots.header || $scopedSlots.title || title">
      <slot name="header">
        <h4 class="awl-card--title" v-if="$scopedSlots.title || title">
          <slot name="title">{{ title }}</slot>
        </h4>
      </slot>
    </div>

    <div class="awl-card--content">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'awl-card',
  props: {
    border: {
      type: Boolean,
      default: false,
    },
    boxShadow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
  },
};

</script>

<style lang="scss">

.awl-card {
  width: 100%;
  border: none;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  padding: 15px 0;
  background: #fff;

  &.bordered {
    border: 1px solid #ccc;
  }

  .awl-card--title {
    margin: 0;
    padding: 15px 20px 0;
    color: $primary;
    text-transform: uppercase;
    font-weight: 500;
    line-height: 1.2;
    font-size: 1.8rem;
  }

  .awl-card--content {
    width: 100%;
  }
}

</style>
